module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAASFJREFUKBWFkr1KxEAUhY2rqdaIxZpsIAkJ6FaChY1gsa2FrU9hZ+dTyPoKgqWVT2Chgr0/1UIK/7AQi+iCxO/oZDGbmD3wMXfuuQcmM2nNTJfFSA/a8DZ9/Hdil+URbmEId7AFjTrAVWD9z9Q29RPoBLVS6Aa8GneP3kml77ruKc3/Qppfgfs5VYXiOL7KsmyD/Rro2+q0TPNlbCjked6XbdsKNekMc/9nIAzDQ474aVnWNQ2nIXWEdw6zxcwFxQ7IUF0XLrwF/LF07atmN2AthX3f1/4SSiHNv8KSCqMivJgkyTAIghH9ytO0aMqY1CCKog8T6k6aeo4OzEPf1LrujuM4m3mej9I07bF/gJL0A+sidFM6rt7n2ayqj+EdKvoGqYI9RnukeV4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/pen.png
// module id = U1DB
// module chunks = 2 5